import * as React from 'react';
import { Drawer, Button } from 'antd';
import injectSheet from 'react-jss';
import ConversationComments from './ConversationComments';

const styles = theme => ({
});
class ConversationCommentsDrawer extends React.PureComponent<any, any> {
  state = {
    creatingBooking: false,
    viewBreakdownVisible: false,
    chargeDetails: {},
    bookingFFModalVisible: false,
  };

  render() {
    const {
      visible,
      sourceObjectId,
      queryString,
      header,
      commentApiPrefix,
    } = this.props;
    return <Drawer
      closable={false}
      onClose={this.props.handleCancel}
      width={1000}
      visible={visible}
      title={header}>
      <ConversationComments
        sourceObjectId={sourceObjectId}
        queryString={queryString}
        commentApiPrefix={commentApiPrefix}
        searchApi={this.props.searchApi} />
    </Drawer>;
  }
}
export default injectSheet(styles)(ConversationCommentsDrawer);
